import { annotatorClient } from './annotatorClient';
import type { AnnotatorProject, ImportPreview } from '../types/annotator';

function normalizeLabel(raw: any) {
  return { id: raw.id, name: raw.name, color: raw.color ?? raw.colour ?? '#FF0000' };
}

function normalizeProject(raw: any): AnnotatorProject {
  return { ...raw, labels: Array.isArray(raw.labels) ? raw.labels.map(normalizeLabel) : [] };
}

export async function previewImport(file: File): Promise<ImportPreview> {
  const form = new FormData();
  form.append('file', file);
  return annotatorClient.postForm<ImportPreview>('/import/preview', form);
}

export async function executeImport(
  file: File,
  projectName: string,
  classes: string[],
  organisationId: number,
): Promise<AnnotatorProject> {
  const form = new FormData();
  form.append('file', file);
  form.append('project_name', projectName);
  form.append('classes', JSON.stringify(classes));
  form.append('organisation_id', String(organisationId));
  const data = await annotatorClient.postForm<any>('/import/execute', form);
  return normalizeProject(data);
}

export interface ImportToProjectPreview {
  classes: string[];
  image_count: number;
  label_file_count: number;
  class_mapping: {
    zip_index: number;
    zip_class: string;
    matched_label_id: number | null;
    matched_label_name: string | null;
  }[];
  project_labels: { id: number; name: string; class_index: number }[];
}

export async function previewImportToProject(projectId: number, file: File): Promise<ImportToProjectPreview> {
  const form = new FormData();
  form.append('file', file);
  return annotatorClient.postForm<ImportToProjectPreview>(`/import/project/${projectId}/preview`, form);
}

export async function importToProject(
  projectId: number,
  file: File,
  createMissingLabels: boolean = true,
): Promise<AnnotatorProject> {
  const form = new FormData();
  form.append('file', file);
  form.append('create_missing_labels', String(createMissingLabels));
  const data = await annotatorClient.postForm<any>(`/import/project/${projectId}`, form);
  return normalizeProject(data);
}
